export const filteredJoin = (parts: (string | null)[], separator: string) => {
    const filteredParts = parts.filter(part => part !== null && part !== '');
    return filteredParts.length > 0 ? filteredParts.join(separator) : '';
};
